import React, { Component } from 'react';

class Timer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            timer: null,
            counter: 0
        };
        this.tick = this.tick.bind(this);
    }

    componentDidMount() {
        let timer = setInterval(this.tick, 1000);
        this.setState({timer});
        this.setState({counter: 0});
    }

    componentWillUnmount() {
        clearInterval(this.state.timer);
    }

    tick() {
        this.setState({
          counter: this.state.counter + 1
        });
    }

    render() {
        let sec_num = this.state.counter;
        let hours   = Math.floor(sec_num / 3600);
        let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        let seconds = sec_num - (hours * 3600) - (minutes * 60);
    
        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        let time = hours+':'+minutes+':'+seconds;
        return (
            <div>
                <h2>Time elapsed in this conversation</h2>
                <h2>{time}</h2>
            </div>
        );
    }
}
export default Timer;


// WEBPACK FOOTER //
// ./src/components/Timer.js